import { VenueAnalyticsGraphImpressionData } from '@models/venue/VenueAnalyticsGraph'
import { Card, Empty, theme } from 'antd'
import dayjs from 'dayjs'
import {
  Bar,
  ComposedChart,
  ReferenceArea,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import CustomTooltip from '../common/CustomTooltip'

interface Props {
  chartData: VenueAnalyticsGraphImpressionData | undefined
  isLoading: boolean
  error?: string
}

const VenueOpening = ({ chartData, isLoading, error }: Props) => {
  const { token } = theme.useToken()

  interface CustomizedAxisTickProps {
    x: number
    y: number
    stroke?: string
    payload: {
      value: string
    }
  }
  const CustomizedAxisTick: React.FC<CustomizedAxisTickProps> = ({
    x,
    y,
    payload,
  }) => {
    return (
      <g transform={`translate(${x},${y})`}>
        <text x={20} y={0} dy={16} textAnchor="end" fill="#bbb">
          {dayjs(payload.value).format('DD MMM')}
        </text>
      </g>
    )
  }
  const renderCustomizedLabel = (props: any) => {
    const { viewBox } = props
    return (
      <g>
        <rect
          x={viewBox.x - 60}
          y={viewBox.y - 10}
          width={120}
          height={20}
          fill="#fff"
        />
        <text
          x={viewBox.x}
          y={viewBox.y}
          fill="#41243F"
          textAnchor="middle"
          dominantBaseline="middle"
        >
          Push notification
        </text>
      </g>
    )
  }
  const renderCustomizedLabel2 = (props: any) => {
    const { viewBox } = props
    return (
      <g>
        <text
          x={viewBox.x + viewBox.width / 2}
          y={viewBox.y + 20}
          fill="#41243F"
          textAnchor="middle"
          dominantBaseline="middle"
        >
          Featured
        </text>
      </g>
    )
  }
  return (
    <Card loading={isLoading}>
      {chartData && (
        <>
          {((chartData.openings ?? []).length === 0 || error) && !isLoading && (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={error} />
          )}
          {(chartData.openings ?? []).length > 0 && !isLoading && !error && (
            <ResponsiveContainer width="100%" height={383}>
              <ComposedChart
                width={500}
                height={400}
                data={chartData.openings}
                margin={{
                  top: 10,
                  right: 30,
                  left: 0,
                  bottom: 0,
                }}
              >
                <YAxis
                  dataKey="count"
                  tickLine={false}
                  stroke={'#bbb'}
                  width={35}
                />
                <XAxis
                  dataKey="label"
                  tickLine={false}
                  stroke={'#bbb'}
                  height={25}
                  tick={(props) => <CustomizedAxisTick {...props} />}
                />
                <Tooltip
                  content={(props) => (
                    <CustomTooltip
                      type="bar"
                      {...props}
                      valueFormatter={(val) => {
                        return val + '  views'
                      }}
                      customLabelFormatter={(payload) => {
                        return payload.label
                      }}
                    />
                  )}
                />
                <Bar dataKey="count" fill={token.colorPrimary} />
                {chartData.notificationPush.map((notification) => (
                  <ReferenceLine
                    key={`notification-${notification.date}`}
                    x={notification.date}
                    stroke="#41243F"
                    label={renderCustomizedLabel}
                  />
                ))}

                {chartData.featuredVenue.map((featured) => (
                  <ReferenceArea
                    key={`featured-${featured.start}-${featured.end}`}
                    x1={featured.start}
                    x2={featured.end}
                    stroke="#41243F"
                    strokeOpacity={1}
                    fill="#968996"
                    fillOpacity={0.2}
                    label={renderCustomizedLabel2}
                  />
                ))}
              </ComposedChart>
            </ResponsiveContainer>
          )}
        </>
      )}
    </Card>
  )
}

export default VenueOpening
